import styled from 'styled-components'

// All component styles have been moved to their respective component files in the Files folder
// This file is kept for backwards compatibility if needed
export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

// Header action button (same style as Notes/Deals tabs)
export const HeaderActionButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.primaryHover};
    transform: translateY(-1px);
    box-shadow: ${({ theme }) => theme.shadows.md};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
